module.exports = __webpack_public_path__ + "assets/img/prev.b45dbe96.svg";